import { render } from "./MobileHeader.vue?vue&type=template&id=33fbbd4a&scoped=true"
import script from "./MobileHeader.vue?vue&type=script&lang=js"
export * from "./MobileHeader.vue?vue&type=script&lang=js"

import "./MobileHeader.vue?vue&type=style&index=0&id=33fbbd4a&scoped=true&lang=scss"

import exportComponent from "/home/caleb/Desktop/apps/kff_ordering_portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33fbbd4a"]])

export default __exports__